import React from "react";
import DoneOutlined from "@material-ui/icons/DoneOutlined";

export type InlineAlertSuccessProps = {
  message: string;
};

export const InlineAlertSuccess = (props: InlineAlertSuccessProps) => {
  return (
    <div className="inline-alert-success font-weight-bold">
      <DoneOutlined />
      <span> {props.message}</span>
    </div>
  );
};
